import React, { memo, useContext, useEffect, useState } from "react";
import { IpkgDestCat } from "../../../types/global";
import LangContext from "../../../context/LangContext";
import PkgDestCategoryService from "../../../services/PkgDestCategory.service";

const MblGlobalDrpDwn: React.FC<HandleRouteProps> = ({ handleRoute }) => {
  const handleNavigationToPkg = (id: string) => {
    handleRoute(
      {
        "nav-item": {
          en: "Global Packages",
          fr: "forfaits globaux",
        },
        to: "/trek-au-nepal",
      },
      {
        pkgCategory: id,
      }
    );
  };
  const [data, setData] = useState<IpkgDestCat[]>([]);
  const { lang_id } = useContext(LangContext);
  const fetchGlobalPkgCategory = async () => {
    try {
      const res = await PkgDestCategoryService.fetchCategories(
        `?package_type=global&lang_id=${lang_id}`
      );
      console.log(res, "=====>>>");
      setData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (lang_id) {
      fetchGlobalPkgCategory();
    }
  }, [lang_id]);

  return (
    <div className={`bg-white pl-2 h-full  text-black`}>
      <div className={`grid grid-cols-1 gap-10`}>
        <div>
          <h1 className="font-semibold text-lg mt-3">Our Best Packages</h1>
          <hr className="my-2" />
          <div className="my-4">
            {data.map((item, i) => (
              <div
                key={i}
                className="my-4 relative group"
                onClick={() => handleNavigationToPkg(item.id)}
              >
                {/* side green bar showing on hover  */}
                <p className="  bg-white w-1 h-4 absolute top-1 -left-4 group-hover:bg-primary-base"></p>

                <p className="text-gray-800 group-hover:text-primary-base font-medium text-base  capitalize">
                  {item.translations[0]?.category_title}
                </p>
                <div className="flex items-center space-x-2">
                  <p className="text-xs font-medium text-gray-500 mt--0.5">
                    {item.packages} packages available
                  </p>
                  {/* {pkg.upcomingTrips && <p className='text-sm text-optional'>{pkg.upcomingTrips} upcoming trips</p>} */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(MblGlobalDrpDwn);
